import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Dialog from '../components/dialog/Dialog'
import styles from './ConfirmDefaultTipDialog.module.scss'

const ConfirmDefaultTipModal = ({ tipPercentage, onConfirm, onCancel, isKiosk, className }) => {
  const classNames = cn(styles.confirmDefaultTipDialog, className)
  const dialogText = `Confirm ${tipPercentage} Suggested Tip`
  const dialogSubtext = "Our staff appreciates your generosity"

  const handleConfirm = () => {
    onConfirm()
    onCancel()
  }

  return (
    <Dialog className={classNames} isKiosk={isKiosk}>
      <div className={isKiosk? styles.kioskContainer : styles.container}>
        {isKiosk ? (
          <div className={styles.textBox}>
          <h1 className={styles.headerText}>{dialogText}</h1>
          <span className={styles.subtext}>{dialogSubtext}</span>
        </div>
        ) :
        <>
          <div className={styles.textBox}>
            <span className={styles.headerText}>{dialogText}</span>
          </div>
          <div className={styles.textBox} >
            <span className={styles.subtext}>{dialogSubtext}</span>
          </div>
          
        </>
        }
        
        <div className={styles.buttonContainer}>
          <div className={isKiosk ? styles.button1 : styles.button} onClick={onCancel}>
            CANCEL
          </div>
          <div className={isKiosk ? styles.button2 : styles.button} onClick={handleConfirm}>
            CONFIRM
          </div>
        </div>
      </div>
    </Dialog>
  )
}

ConfirmDefaultTipModal.defaultProps = {
  onConfirm: () => {},
  onCancel: () => {},
}

ConfirmDefaultTipModal.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default ConfirmDefaultTipModal
